/**
 * User details resolver promise. Let's aim to prevent multiple calls when there are multiple forms/calls.
 *
 * @type {Promise<unknown>}
 * @private
 */
let _userDetailsResolver = null;

/**
 * Return a promise which asynchronously resolves user data from the window, or via AJAX as
 * a fallback, and resolves with the user data.
 *
 * @return {Promise<unknown>}
 */
function resolveCurrentUserDetails() {

    // Return existing promise for immediate resolution if already set.
    if (_userDetailsResolver) {
        return _userDetailsResolver;
    }

    _userDetailsResolver = new Promise((resolve, reject) => {

        // Attempt to get the user details from an object defined in the global scope.
        if (typeof window.agend_pi_user_details !== 'undefined') {
            resolve(window.agend_pi_user_details);
        } else {
            if (typeof jQuery === 'undefined') {
                reject('Cannot resolve jQuery for fetching data asynchronously.');
                return;
            }

            // Otherwise get the current user details asap...
            jQuery.getJSON('/wp-admin/admin-ajax.php?action=ajax_get_current_user')
                .success(function (data) {
                    resolve(data);
                })
                .fail(function (error) {
                    reject(error)
                });
        }
    });

    return _userDetailsResolver;
}


// Additional validation for Attendee Details Forms.
jQuery(function ($) {

  /**
   * Ensure the checkbox is ticked.
   *
   * @returns boolean
   */
  function agendValidateTandCsCheckbox() {
    const $checkbox = $('#agend_terms_and_conditions');
    if (!$checkbox.length) {
      return true;
    }

    // Hide error message.
    if ($checkbox.is(':checked')) {
      $('.js-tac-error').addClass('agend-is-hidden');

      return true;
    } else {
      // Show error message.
      $('.js-tac-error').removeClass('agend-is-hidden');

      // Hide the modal added by Tribe.
      $('.tribe-common-c-loader').addClass('tribe-common-a11y-hidden');

      return false;
    }
  }

  /**
   * Make a form field read only.
   *
   * @param $field
   * @param val
   */
  function makeFieldReadOnly($field, val) {
    if (!$field.length || !val.length) {
      return;
    }

    $field
      .attr('type', 'hidden')
      .after(val);
  }


  /**
   * Prefill an empty attendee details form with the current user's details.
   *
   * @param $form
   */
  function prefillEmptyForm($form) {
      const disablePopulation = $('body').hasClass( 'agend-pi-disable-attendee-form-population' );
      if(disablePopulation){
          return;
      }

      resolveCurrentUserDetails()
          .then(userDetails => {

              const $nameField = $form.find('input[name*="name"]:first');
              const $emailField = $form.find('input[name*="email"]:first');
              const $mobileField = $form.find('input[name*="mobile"]:first');
              const makeReadonly = $('body').hasClass( 'agend-pi-event-registration-first-attendee-readonly' );

              // Historically this is the name for this registration field.
              const $dietaryAndSpecialRequirementsField = $form.find('textarea[name*="dietary-and-special-requirements"]:first');

              let $specialRequirements = $form.find('textarea[name*="special-requirements"]:first');
              let $dietaryRequirements = $form.find('select[name*="dietary-requirements"]:first, select[name*="dietary-option"]:first');
              const $saveYourDietaryAndSpecialRequirements = $form.find('input[name*="save-your-dietary-and-special-requirements"][value="Yes"]');
              const $optIntoThirdPartyComms = $form.find('input[name*="allow-my-details-to-be-shared-with-event-sponsors"][value="Yes"]');
              const readOnlyFieldClass = 'tribe-tickets__form-field-input--agend-pi-first-attendee-readonly';

              // Must have at least the name field and email field.
              if ($nameField.length === 0 || $emailField.length === 0) {
                  return;
              }

              let isFormEmpty = true;
              $form.find('input[type=text], textarea').each(function () {
                  if ($(this).val().length > 0) {
                      isFormEmpty = false;
                      return false;
                  }
              });

              // Default this radio field to checked if form is empty.
              if ($saveYourDietaryAndSpecialRequirements.length && isFormEmpty) {
                  $saveYourDietaryAndSpecialRequirements.attr('checked', true);
              }

              // Default this radio field to checked if form is empty.
              if ($optIntoThirdPartyComms.length && isFormEmpty) {
                  $optIntoThirdPartyComms.attr('checked', true);
              }

              if (('user_firstname' in userDetails) && ('user_lastname' in userDetails)) {
                  let userFullName = userDetails.user_firstname + ' ' + userDetails.user_lastname;

                  if(userFullName.length > 0){
                      $nameField.val(userFullName);
                      $nameField.get(0).dispatchEvent(new Event('change'));

                      if (makeReadonly) {
                          makeFieldReadOnly($nameField, userFullName);
                          $nameField.addClass(readOnlyFieldClass);
                      }
                  }
              }

              if ('user_email' in userDetails) {
                  let userEmail = userDetails.user_email;

                  if(userEmail.length > 0){
                      $emailField.val(userEmail);
                      $emailField.get(0).dispatchEvent(new Event('change'));

                      if (makeReadonly) {
                          makeFieldReadOnly($emailField, userEmail);
                          $emailField.addClass(readOnlyFieldClass);
                      }
                  }
              }

              if ($mobileField.length) {
                  let userMobile = '';

                  if ('business_mobile' in userDetails && userDetails.business_mobile !== '') {
                      userMobile = userDetails.business_mobile;
                  } else if ('home_mobile' in userDetails && userDetails.home_mobile !== '') {
                      userMobile = userDetails.home_mobile;
                  }

                  // Prefill if a mobile exists.
                  if (userMobile.length > 0) {
                    $mobileField.val(userMobile);
                    $mobileField.get(0).dispatchEvent(new Event('change'));

                    if (makeReadonly) {
                        makeFieldReadOnly($mobileField, userMobile);
                        $mobileField.addClass(readOnlyFieldClass);
                    }
                  }
              }

              if ($dietaryAndSpecialRequirementsField.length) {
                  if ('dietary_requirements' in userDetails) {
                    // Prefill if there's no value saved already.
                    if ( $dietaryAndSpecialRequirementsField.val() === '' ) {
                      $dietaryAndSpecialRequirementsField.val(userDetails.dietary_requirements);
                      $dietaryAndSpecialRequirementsField.get(0).dispatchEvent(new Event('change'));
                    }
                  }
              }

              if ($dietaryRequirements.length) {
                  if ('dietary_requirements' in userDetails) {
                      // Prefill if there's no value saved already.
                      if ( $dietaryRequirements.val() === '' ) {
                        $dietaryRequirements.find('option[value="' + userDetails.dietary_requirements + '"]').attr('selected', true);
                        $dietaryRequirements.get(0).dispatchEvent(new Event('change'));
                      }
                  }
              }

              if ($specialRequirements.length) {
                  if ('special_requirements' in userDetails) {
                      // Prefill if there's no value saved already.
                      if ( $specialRequirements.val() === '' ) {
                        $specialRequirements.val(userDetails.special_requirements);
                        $specialRequirements.get(0).dispatchEvent(new Event('change'));
                      }
                  }
              }

              // Allow client plugins to alter pre-filled values when the form was empty. Allows changing opinionated defaults set above.
              if(isFormEmpty){
                  $.publish('/event-registration/prefill-user-fields-for-empty-form', [userDetails, $form]);
              }

              // Allow client plugins to prefill further user fields in this form.
              $.publish('/event-registration/prefill-user-fields', [userDetails, $form]);
          })
          .catch(error => {
                console.warn('There was an error resolving user details to pre-fill the form', error);
          });

  }



  // ---- Modal form.
  if (typeof window.tribe !== 'undefined' &&
    typeof window.tribe.dialogs !== 'undefined' &&
    typeof window.tribe.dialogs.events !== 'undefined') {

    $(window.tribe.dialogs.events).on('tribe_dialog_show_ar_modal', function () {

      // Wait about 10 seconds.
      const maxRetries = 100;
      let retries = 0;

      function waitForUserModal() {
        retries++;
        if (retries >= maxRetries) {
          // We want to know about this error.
          throw new Error( 'Agend cannot find form fields inside the modal to prefill. Max number of retries reached.');
        }

        const $modalForm = $('#tribe-tickets__modal-form');
        if (!$modalForm.length) {
          setTimeout(waitForUserModal, 100);
          return;
        }
        $modalForm.submit(function () {
          return agendValidateTandCsCheckbox();
        });

        const $registrationEvents = $modalForm.find('.tribe-tickets__attendee-tickets-container:visible');

        if ($registrationEvents.length) {
          $registrationEvents.each(function (i, el) {
            prefillEmptyForm($(el));
          });
        } else {
          setTimeout(waitForUserModal, 100);
        }
      }

      waitForUserModal();
    });
  }


  // ---- Post-cart form.
  const $registrationForm = $('#tribe-tickets__registration-form');
  if (!$registrationForm.length) {
    return;
  }

  $registrationForm.submit(function () {
    return agendValidateTandCsCheckbox();
  });

  $(window).on('tribe_et_after_form_prefills', function () {
    function waitForUserPostCart() {
      const $registrationEvents = $registrationForm.find('.tribe-tickets__attendee-tickets-container');
      if ($registrationEvents.length) {
        $registrationEvents.each(function (i, el) {
          const $emptyForm = $(el);
          prefillEmptyForm($emptyForm);
        });
      } else {
        setTimeout(waitForUserPostCart, 100);
      }
    }

    waitForUserPostCart();
  });
});
